import { Box } from "@mui/material";
import { Typography } from "@powerdiary/components-library/lib";
import CalendarLegend from "./CalendarLegend";
import CalendarMonthPicker from "./CalendarMonthPicker";
import { DateTime } from "luxon";

interface ICalendarHeaderProps {
    currentMonth: DateTime;
    goToPreviousMonth: () => void;
    goToNextMonth: () => void;
}

export default function CalendarHeader({ currentMonth, goToPreviousMonth, goToNextMonth }: ICalendarHeaderProps) {
    return (
        <Box data-test-id="section_calendar_header">
            <Typography mb={3} variant="heading4" data-test-id="availability_title">
                Select a date and time
            </Typography>

            <CalendarLegend />

            <CalendarMonthPicker
                currentMonth={currentMonth}
                onPreviousMonth={goToPreviousMonth}
                onNextMonth={goToNextMonth}
            />
        </Box>
    );
}
